import _kebabCase from 'lodash/kebabCase';
import { userHasShippingAddress } from 'core/api/Account';

export const ONRAMP_ROUTES_NAMESPACE = 'onramp';

export const onrampPath = (step) => `/${ONRAMP_ROUTES_NAMESPACE}/${_kebabCase(step)}`;

export const ROUTES = [
  {
    name: 'signIn', //This is used to sign in users who have not created any orders or passwords.
    isComplete: (user) => !!(user?.email && user?.primaryAddress?.zipCode),
  },
  {
    name: 'signUp',
    isComplete: (user) => !!(user?.email && user?.primaryAddress?.zipCode),
  },
  {
    name: 'initOrder',
    isComplete: (user) => !!(user?.email && user?.primaryAddress?.zipCode) && (!!(user?.nextOneTimeProgram) || !!(user?.subscription)),
    // enable: (user) => user && !user.reorder,
  },
  {
    name: 'newBillingInfo',
    isComplete: (user) => !!(user?.billingAccount?.active),
  },
  {
    name: 'prepaidConfirmation',
    enabled: (user) => userHasShippingAddress(user) || !!user.nextOneTimeProgram,
  },
  {
    name: 'orderManagement',
    isComplete: (user) => !!(user?.email && user?.reorder),
  },
].map((route) => ({ path: onrampPath(route.name), ...route }));

const UNSEQUENCED_ROUTES = [
  {
    name: 'outOfDeliveryZone',
  },
  {
    name: 'productDescription',
    path: '/onramp/:deliveryDayId/product-description/:componentId',
  },
  {
    name: 'editWeekMenu',
    path: '/onramp/edit-week-menu/:deliveryDayId',
  },
  {
    name: 'selectMeal',
    path: '/onramp/select-meal/:deliveryDayId/:componentId',
  },
  {
    name: 'myOrder',
    path: '/onramp/my-order',
  },
  {
    name: 'confirmation',
    path: '/onramp/confirmation/:invoiceId',
  },
  {
    name: 'myProgram',
    path: '/onramp/my-program',
  },
  {
    name: 'mySettings',
    path: '/onramp/my-settings',
  },
  {
    name: 'orderHistory',
    path: '/onramp/order-history',
  },
  {
    name: 'myInvoices',
    path: '/onramp/my-invoices',
  },
].map((route) => ({ path: onrampPath(route.name), ...route }));

export const ROUTE_MAP = [...ROUTES, ...UNSEQUENCED_ROUTES].reduce((obj, route) => ({ ...obj, [route.name]: route }), {});

export const onrampStart = () => ROUTES[0].path;

export const onrampSequenceForUser = (user, cache) => {
  return ROUTES.filter((route) => route.enabled ? route.enabled(user, cache): true);
};

// FIXME: this should use onrampSequenceForUser
export const stepNumber = (pathName) => ROUTES.findIndex((r) => r.path === pathName.replace(/\/+$/, '')) + 1;

// FIXME: this should use onrampSequenceForUser
export const stepCount = () => ROUTES.length;

export default ROUTES;
